import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"
import pt from "intl-tel-input/locale/pt"

// Campo de telefone internacional: o input visível é controlado pelo
// intl-tel-input (seletor de país + máscara) e o hidden carrega o E.164
// que o servidor grava.
export default class extends Controller {
  static targets = ["input", "hidden"]
  static values = { number: String }

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: "br",
      onlyCountries: ["br", "uy"],
      countryOrder: ["br", "uy"],
      separateDialCode: true,
      nationalMode: true,
      strictMode: true,
      // Com dois países na lista, a busca só atrapalha.
      countrySearch: false,
      uiTranslations: pt,
      countryNameLocale: "pt",
      countryNameOverrides: { br: "Brasil", uy: "Uruguai" },
      // O card do checkout tem overflow-hidden, que recortaria a lista de
      // países se ela ficasse dentro do campo.
      dropdownParent: document.body,
      loadUtils: () => import("intl-tel-input/utils")
    })

    if (this.numberValue) this.iti.setNumber(this.numberValue)

    this.sync = this.sync.bind(this)
    this.inputTarget.addEventListener("input", this.sync)
    this.inputTarget.addEventListener("countrychange", this.sync)
    this.sync()
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.sync)
    this.inputTarget.removeEventListener("countrychange", this.sync)
    this.iti?.destroy()
  }

  sync() {
    this.hiddenTarget.value = this.iti.getNumber() || ""
    this.hiddenTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
